import React from "react";
import LsLoading from "Components/LsLoading";

interface LoadingPlaceholderProps {

}

const LoadingPlaceholder: React.FC<LoadingPlaceholderProps> = () => {
   return <div className="explore-loading reloading">
      <LsLoading isLoading />
   </div>;
}

export default LoadingPlaceholder;